<!-- loading spinner -->
<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">

  <div class="field grid">
    <label class="col-fixed">Application Name</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="application-name" id="application-name"
             readonly="readonly" pInputText formControlName="applicationName" />
      <div class="config-validation-message" [hidden]="!form.controls['applicationName']?.errors?.required">
        Application Name is required.
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['applicationName']?.errors?.maxlength">
        Must
        be shorter than 150 characters
      </div>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed" for="support-telephone">Support Tel. No.</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="support-telephone" id="support-telephone" pInputText
             formControlName="supportTelNo" />
      <div class="config-validation-message" [hidden]="!form.controls['supportTelNo']?.errors?.required">
        Support
        Tel. No. is required.
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['supportTelNo']?.errors?.maxlength">
        Must be
        shorter than 100 characters
      </div>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed" for="support-email-signature">Email Signature</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="support-email-signature" id="support-email-signature" pInputText
             formControlName="emailSignature" />
      <div class="config-validation-message" [hidden]="!form.controls['emailSignature']?.errors?.required">
        Email
        Signature is required.
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['emailSignature']?.errors?.maxlength">
        Must be
        shorter than 250 characters
      </div>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed" for="product-url">Support Email</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="support-email" id="support-email" pInputText
             formControlName="supportEmailAddress" />
      <div class="config-validation-message" [hidden]="!form.controls['supportEmailAddress']?.errors?.required">
        Support Email is required.
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['supportEmailAddress']?.errors?.maxlength">
        Must be shorter than 150 characters
      </div>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed" for="product-url">Company Website</label>
    <div class="col-fixed inputfield">
      <input class="form-control" name="company-website" id="company-website" pInputText
             formControlName="companyWebSite" />
      <div class="config-validation-message" [hidden]="!form.controls['companyWebSite']?.errors?.required">
        Company
        Website is required.
      </div>
      <div class="config-validation-message" [hidden]="!form.controls['companyWebSite']?.errors?.maxlength">
        Must be
        shorter than 150 characters
      </div>
    </div>
  </div>

</form>
